import {
  UiHStack,
  UiImage,
  uiStyles,
  type UiHStackProps,
  UiStack,
  UiText,
  UiIconArrowRight,
  UiBox, UiIconGear, UiIconLayout,
} from '@/lib/ui';
import {
  useDisclosure
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useCallback, type FC } from 'react';
import { type registration } from '@/api';
import BaseButtonPlainIconEdit from '@/base/Button/PlainIconEdit';
import BasePlainIcon from '@/base/Button/PlainIcon';
import BadgeForm from '@/registration/manage/RegistrationBadge/BadgeForm';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { generatePageUrl } from '@/app/pages';
import { useNavigate } from 'react-router-dom';

dayjs.extend(utc);

export interface BadgeRowProps extends UiHStackProps {
  data: registration.RegistrationBadgeTableRow
}

const BadgeRow: FC<BadgeRowProps> = ({
  data,
  ...props
}) => {
  const { isOpen, onToggle } = useDisclosure();
  const { tenantCode } = useRegisterRoute();
  const navigate = useNavigate();

  const toDesignPage = useCallback(() => {
    if (tenantCode) {
      navigate(generatePageUrl('BadgeDesigner', { tenantCode, badgeId: `${data?.id}` }));
    }
  }, [
    tenantCode,
  ]);

  return (
    <>
      <UiHStack
        py={4}
        px={8}
        bgColor={'#fff'}
        // px={8}
        flexGrow={1}
        spacing={4}
        justifyContent={'space-between'}
        {...uiStyles.hoverFlex({ bgColor: 'gray.50' })}
        {...props}
      >
        {/* <UiStack spacing={1}> */}
        {/*  <UiText variant={'body2'} color={'text.secondary'}>ID: {data.id}</UiText> */}
        {/*  <UiText>{data.title ?? ''}</UiText> */}
        {/* </UiStack> */}
        <UiStack>
          <UiText>
            {data.title ?? ''}
          </UiText>
        </UiStack>
        <UiHStack spacing={8}>
          <BaseButtonPlainIconEdit onClick={onToggle} />
          <BasePlainIcon
            label={'Design'}
            Icon={UiIconLayout}
            onClick={toDesignPage}
          />
        </UiHStack>
      </UiHStack>
      <BadgeForm
        // onSubmit={}
        onClose={onToggle}
        onSaveSuccess={() => {}}
        isVisible={isOpen}
        badgeId={Number(data.id)}
      />
    </>
  );
};

export default BadgeRow;
